/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { combineReducers } from 'redux';
import applicationReducer, { ApplicationStateProps } from './application';
import dashboardDoughnutReducer from './doughnutGraph';
import monthOnMonthReducer from './monthsGraph';
import topDistributorReducer from './topDistributors';
import commitmentAndContributionReducer from './commitmentAndContributionGraph';
import auth from './auth';
import errorReducer, { ErrorState } from './error';
import investorReducer from './investor';
import profileReducer from './profile';
import paramsReducer, { ParamsProps } from './queryParams';
import toast, { ToastType } from './toast';
import { mdmsProp, mdmsDataReducer } from './mdmsData';
import {
  dashboardOnboardingType,
  distributorWisecommitmentType,
  getAuthorizedSignatoriesDetailsByRefrenceType,
  getDetailsByRefrenceType,
  monthwiseCommitmentAmountType,
  monthwiseOnboardingSummaryType,
  OnboardingFilterType,
} from '../types/api-types';
import refrenceIdReducer from './refrenceId';
import kycReducer, { KYCApplicationStateProps } from './kycApplication';
import kycInvestorReducer from './kycInvestor';
import dashboardFiltersReducer from './onboardingdata';
export interface RootStateType {
  auth: any;
  router: any;
  profileReducer: any;
  dataDougnut: dashboardOnboardingType;
  monthOnMonthData: monthwiseOnboardingSummaryType;
  topDistributors: distributorWisecommitmentType;
  commitmentAndContributionData: monthwiseCommitmentAmountType;
  application: ApplicationStateProps;
  kycApplication: KYCApplicationStateProps;
  toast: ToastType;
  investor: any;
  kycInvestor: any;
  error: ErrorState;
  paramsObj: ParamsProps;
  refrenceIdReducer: getDetailsByRefrenceType | getAuthorizedSignatoriesDetailsByRefrenceType;
  mdmsDataReducer: mdmsProp;
  dashboardFilters: OnboardingFilterType;
}

export const rootReducer = (history: any) =>
  combineReducers({
    router: history,
    auth,
    profile: profileReducer,
    application: applicationReducer,
    kycApplication: kycReducer,
    dataDougnut: dashboardDoughnutReducer,
    monthOnMonthData: monthOnMonthReducer,
    commitmentAndContributionData: commitmentAndContributionReducer,
    topDistributors: topDistributorReducer,
    toast,
    investor: investorReducer,
    kycInvestor: kycInvestorReducer,
    error: errorReducer,
    paramsObj: paramsReducer,
    refrenceIdReducer: refrenceIdReducer,
    mdmsDataReducer,
    dashboardFilters: dashboardFiltersReducer,
  });

export type RootState = ReturnType<typeof rootReducer>;
